<template>
  <div class="queue-item">
    <ItemStatus :order="append.data" :cafe="cafe" />
    <div class="content">
      <h5 class="queue-client" v-if="append.data.client">{{ $t('card.client') }} {{ append.data.client }}</h5>

      <ItemList
        mode="stock"
        :list="append.data.list"
        @toggleAvailability="emitToggleAvailability"/>

      <div class="comment" v-if="append.data.comment">
        <b>{{ $t('card.comment') }}</b>
        <p>{{ append.data.comment }}</p>
      </div>
      <!-- <h3 v-if="order.status == 'paying'">
        {{ $t('card.total') }}
        <span class="total float-right">{{ OrderHelpers.computeOrderTotal(append.data) }}₴</span>
      </h3> -->
    </div>
    <ItemActions
      :order="append.data"
      @cancel="emitCancel"
      @accept="emitAccept"/>
  </div>
</template>

<script>
import ItemStatus from "@/components/item/ItemStatus.vue";
import ItemList from "@/components/item/ItemList.vue";
import ItemActions from "@/components/item/ItemActions.vue";

import QueueButton from "@/components/QueueButton.vue";

import OrderHelpers from "@/services/order/helpers.js";

export default {
  props: {
    append: Object
  },
  data() {
    return {
      OrderHelpers
    };
  },
  methods: {
    emitAccept() {
        this.$emit('accept', this.append.order_id, this.append.append_index);
    },
    emitCancel() {
        this.$emit('cancel', this.append.order_id, this.append.append_index);
    },
    emitToggleAvailability(idx) {
        this.$emit('toggleAvailability', this.append.order_id, this.append.append_index, idx);
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    }
  },
  components: {
    ItemStatus,
    ItemList,
    ItemActions,
    QueueButton
  }
};
</script>


<style scoped>

@media (min-width: 768px){
  .comment {
    padding: 1.3888vw;
  }
  .comment b {
    font-size: 1.38888vw;
    color: #A4A3A1;
  }
  .comment p {
    font-size: 1.38888vw;
    margin-left: 0;
  }
  .queue-item {
    width: 28vw !important;
  }
}

@media (min-width: 1200px){
  .comment b {
    font-size: 1.25vw;
  }
  .comment p {
    font-size: 1.111vw;
  }
  .queue-item {
    width: 23.26vw !important;
  }
}

.comment {
  padding: 2.5vh 2.5vh 0;
}

.queue-item {
  background: transparent;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2.5vh 2.5vh 3.3vh 3.3vh;
  width: 90vw;
  padding-bottom: 3.7vh;
  margin: 0 auto 2.7vh;
}

.edit-modal-actions {
  display: flex;
  justify-content: space-between;
  margin: 25px 0px;
}

.total {
  font-size: 36px;
  letter-spacing: -2px;
  margin-top: -9px;
  color: #303030;
}
svg {
  color: #5a5a5a;
  margin:3px 10px 0 0;
}

.btn-add {
  width: 100%;
  font-size: 16px;
  margin-top: 20px;
  padding: 10px 0;
  outline: none;
  display: block;
  border-radius: 25px;
  background: transparent;
  border: 1px solid black;
}

h3 {
  color: #bcbcbc;
  font-weight: bold;
  font-size: 26px;
}

.price {
  font-weight: 500;
  font-size: 24px;
  color: #bcbcbc;
}

p {
  margin-left: 5px;
}

.queue-client {
  padding-bottom: 10px;
  margin-bottom: 0;
}
</style>

